import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Talent } from "../../Types/Talent";

export interface TalentSearchState {
    Result: Talent[];
    ResultsLoading: boolean;
}
const initialState = {
    Result: [],
    ResultsLoading: false
} satisfies TalentSearchState as TalentSearchState;

export const talentSearchSlice = createSlice({
    name: 'TalentSearch',
    initialState,
    reducers: {
        resetTalentSearch() {
            return initialState;
        },
        setTalentSearchResult(state, action: PayloadAction<TalentSearchState["Result"]>) {
            state.Result = action.payload;
        },
        setTalentSearchLoading(state, action: PayloadAction<TalentSearchState["ResultsLoading"]>) {
            state.ResultsLoading = action.payload;
        },
    }
})

export const {
    setTalentSearchResult,
    setTalentSearchLoading
} = talentSearchSlice.actions

export default talentSearchSlice.reducer

